import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutWindow: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutWindow"><Path d="M3 11V3H11V11H3Z" fill="currentColor"/><Path d="M3 13V21L11 21V13H3Z" fill="currentColor"/><Path d="M13 21L21 21V13H13V21Z" fill="currentColor"/><Path d="M21 11V3H13V11H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutWindow;
